import React from 'react';
import PropTypes from 'prop-types';
import Panel from '@spothero/ui/panel';
import HowToRedeem from '../redeem/HowToRedeem';

const HowToRedeemArrivalDeparture = ({selectedRate, facility}) => {
    return (
        <div className="HowToRedeemArrivalDeparture">
            <h4 className="subtitle">How To Redeem</h4>
            <p>
                You will receive an email with redemption instructions after
                making a reservation.
            </p>
            <Panel title="Show redemption instructions" showTitleToggle>
                <HowToRedeem
                    rate={selectedRate}
                    facility={facility}
                    isMonthly={false}
                    isAirport
                    sectionTitle="Arrival"
                    airportSection="arrival"
                />
                <HowToRedeem
                    rate={selectedRate}
                    facility={facility}
                    isMonthly={false}
                    isAirport
                    sectionTitle="Departure"
                    airportSection="departure"
                />
            </Panel>
        </div>
    );
};

HowToRedeemArrivalDeparture.propTypes = {
    selectedRate: PropTypes.object.isRequired,
    facility: PropTypes.object.isRequired,
};

export default HowToRedeemArrivalDeparture;
